export enum DisbursementStatus {
    SCHEDULED = 'SCHEDULED',
    PROCESSING = 'PROCESSING',
    CANCELED = 'CANCELED',
    EXPIRED = 'EXPIRED',
    PAID = 'PAID',
    NOT_PAID = 'NOT_PAID',
}
